import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { RootState } from '../utils/type';
import { auth } from '../pages/auth/services/signin/slice';
import { vendorPayments } from '../pages/reports/services/vendorPayments/slice';
import { chargerStatus } from '../pages/reports/services/chargerStatus/slice';
import { vendorChargerStatus } from '../pages/vendorReports/services/chargerStatus/slice';
import { vendorChargingReport } from '../pages/vendorReports/services/chargingReport/slice';
import { vendorList } from '../pages/vendors/services/vendorList/slice';
import { stationList } from '../pages/stations/services/stationList/slice';
import { vendorCommission } from '../pages/commission/services/vendorCommission/slice';

export const store = configureStore({
  reducer: {
    auth,
    vendorPayments,
    chargerStatus,
    vendorChargerStatus,
    vendorChargingReport,
    vendorList,
    stationList,
    vendorCommission,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
